import styles from "./data-medium-block.module.scss";

const DataMediumBlock = ({children}) => {
    return (
        <div className={styles.wrapper}>
            {children}
        </div>
    )
}

export default DataMediumBlock;